<template>
  <div v-bind="result.attributes" class="catalog-section-item">
    <DefImg v-if="result.picture" :result="result.picture" />
    <a :href="result.detailPage" class="catalog-section-item__link"></a>
    <div class="section-item-content" @click="handlerClick">
      <div v-if="result.name" class="section-item-content__name">
        {{ result.name }}
      </div>
      <div v-if="result.bannerText" class="section-item-content__text" v-html="result.bannerText" />
    </div>
  </div>
</template>

<script setup lang="ts">
import DefImg from '@components/Def/DefImg/DefImg.vue';

const props = defineProps<{
  result: object;
}>();

const handlerClick = () => {
  if (!props.result?.detailPage) return;

  window.location.href = props.result.detailPage;
};
</script>
<style lang="scss" scoped>
.catalog-section-item {
  display: block;
  position: relative;
  overflow: hidden;
  &:hover {
    @include point-lg {
      .section-item-content {
        left: 0px;
        right: 0px;
        height: 100%;
      }
    }
  }
  &__link {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }
}
.section-item-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  left: 16px;
  right: 16px;
  height: 115px;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(7.5px);
  text-align: center;
  padding: 16px 24px;
  transition: left linear 0.3s, right linear 0.3s, height linear 0.3s;
  @include point-md {
    padding: 24px;
    left: 24px;
    right: 24px;
  }
  @include point-lg {
    left: 32px;
    right: 32px;
  }
  &__name {
    font-size: 16px;
    font-weight: 600;
    line-height: 125%;
    text-transform: uppercase;
    margin-bottom: 8px;
    @include point-md {
      font-size: 18px;
    }
  }
  &__text {
    font-size: 12px;
    font-weight: 400;
    line-height: 125%;
    overflow: hidden;
    @include point-md {
      font-size: 14px;
    }
  }
}
</style>
